import React from 'react'
import { Col, Form, Row } from 'react-bootstrap'
import type { ColProps } from 'react-bootstrap'
import { ShowIf } from '../ShowIf'
import styles from './LabelValueBlock.module.scss'

export type LabelValueBlockProps = {
  label?: React.ReactNode
  value: React.ReactNode
  className?: string
  borderBottom?: string
  labelWidth?: ColProps['md'] //whatever the bootstrap colProps is, we use it
}
export const LabelValueBlock = ({
  label,
  value,
  className = 'py-2',
  borderBottom = 'border-bottom',
  labelWidth = 5,
}: LabelValueBlockProps) => {
  const secondColWidth = typeof labelWidth === 'number' ? 12 - labelWidth : undefined

  return (
    // Label column: capitalized and bold at base size, with no `small` — it then reads the same as a
    // sibling plain field's label in the same card (`InlineDisplayContent.tsx`'s `FormLabel`,
    // `text-capitalize fw-bold`) instead of smaller.
    // Value column: weight-neutral, so the only thing that reads as emphasis is a caller's own
    // emphasis on a single row (a totals panel's Net Amount, a refund panel's Refund Total) — a bold
    // stamped here would make every row shout and drown those out. It is also flex with safe
    // flex-end, so a value wider than its column spills to the right instead of over its own label.
    <Row className={`${className} ${borderBottom} `}>
      <ShowIf condition={!!label}>
        <Col md={labelWidth}>
          <Form.Label className={`text-capitalize fw-bold`}>{label}</Form.Label>
        </Col>
      </ShowIf>
      <Col md={secondColWidth} className={`d-flex ${styles.safeEnd}`}>
        {value}
      </Col>
    </Row>
  )
}
